export default __webpack_public_path__ + "static/media/pavilijonki.75d8bc8a.webp";